import React from 'react';
import { AppBar, Toolbar, Typography, Box, Button, Container } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { 
    Home as HomeIcon, 
    Assessment, 
    CloudUpload, 
    Logout,
    Gavel,
    People,
    CreditCard,
    Settings as SettingsIcon,
    Cottage,
    PieChart,
    AccountBalance,
    Receipt as ReceiptNavIcon,
} from '@mui/icons-material';
import { auth } from './firebaseConfig';
import { signOut } from 'firebase/auth';

function Header() {
    const location = useLocation();

    const handleLogout = () => {
        signOut(auth).then(() => {
            localStorage.removeItem('authToken');
            sessionStorage.removeItem('mfaVerified');
            window.location.href = '/login';
        }).catch(console.error);
    };

    const navItems = [
        { path: '/', label: 'Home', icon: <HomeIcon sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/profit-loss', label: 'Analytics', icon: <Assessment sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/upload', label: 'Upload', icon: <CloudUpload sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/tax-summary', label: 'Tax Summary', icon: <Gavel sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/payroll', label: 'Payroll', icon: <People sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/home-office', label: 'Home Office', icon: <Cottage sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/personal-finance', label: 'Personal', icon: <CreditCard sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/personal-expenses', label: 'Expenses', icon: <PieChart sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/linked-accounts', label: 'Accounts', icon: <AccountBalance sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/account-transactions', label: 'Transactions', icon: <ReceiptNavIcon sx={{ fontSize: 18, mr: 0.5 }} /> },
        { path: '/settings', label: 'Settings', icon: <SettingsIcon sx={{ fontSize: 18, mr: 0.5 }} /> },
    ];

    return (
        <AppBar 
            position="sticky" 
            elevation={0}
            sx={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(255,255,255,0.1)'
            }}
        >
            <Container maxWidth="xl">
                <Toolbar sx={{ px: { xs: 0 } }}>
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            p: 0.75,
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                        }}
                    >
                        <img src="/logo.png" alt="Logo" style={{ width: '40px', height: '40px' }} />
                    </Box>
                    <Typography
                        variant="h6"
                        sx={{ 
                            flexGrow: 1, 
                            color: 'white', 
                            ml: 2,
                            fontWeight: 700,
                            letterSpacing: '-0.5px'
                        }}
                    >
                        Ohana Financial
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                        {navItems.map((item) => (
                            <Link
                                key={item.path}
                                to={item.path}
                                style={{ textDecoration: 'none' }}
                            >
                                <Button
                                    sx={{
                                        color: 'white',
                                        px: 2,
                                        py: 1,
                                        borderRadius: 2,
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: location.pathname === item.path 
                                            ? 'rgba(255,255,255,0.2)' 
                                            : 'transparent',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(255,255,255,0.15)',
                                            transform: 'translateY(-2px)'
                                        }
                                    }}
                                >
                                    {item.icon}
                                    {item.label}
                                </Button>
                            </Link>
                        ))}
                        <Button
                            onClick={handleLogout}
                            startIcon={<Logout />}
                            sx={{
                                color: 'white',
                                px: 2,
                                py: 1,
                                ml: 1,
                                borderRadius: 2,
                                fontWeight: 600,
                                textTransform: 'none',
                                backgroundColor: 'rgba(255,255,255,0.1)',
                                border: '1px solid rgba(255,255,255,0.2)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    transform: 'translateY(-2px)'
                                }
                            }}
                        >
                            Logout
                        </Button>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default Header;
